import * as React from 'react';
import { Button, Spinner, Icon, IconType } from 'ui-toolkit';
import './search-report-header-buttons.scss';

export interface ISearchReportHeaderButtons {
  showSaveSpinner: boolean;
  showSaveSuccess: boolean;
  showFinalizeSpinner: boolean;
  showFinalizeSuccess: boolean;
  disableFinalize: boolean;
  onSave: () => void;
  onFinalize: () => void;
}

export class SearchReportHeaderButtons extends React.Component<ISearchReportHeaderButtons, {}> {
  public static defaultProps: Partial<ISearchReportHeaderButtons> = {};

  public render() {
    return (
      <div className={'save-submit-buttons '}>
        <div className={this.props.showSaveSpinner || this.props.showSaveSuccess ? 'button__icon-container' : ''}>
          {this.props.showSaveSuccess ? <Icon type={IconType.Check} /> : null}
          {this.props.showSaveSpinner ? <Spinner className={'button__icon'} /> : null}
          <Button intent="secondary" onClick={this.props.onSave}>
            {' '}
            Save{' '}
          </Button>
        </div>
        <div
          className={this.props.showFinalizeSpinner || this.props.showFinalizeSuccess ? 'button__icon-container' : ''}
        >
          {this.props.showFinalizeSuccess ? <Icon type={IconType.Check} /> : null}
          {this.props.showFinalizeSpinner ? <Spinner className={'button__icon'} /> : null}
          <Button intent="primary" disabled={this.props.disableFinalize ? true : false} onClick={this.onFinalizeClick}>
            {' '}
            Finalize{' '}
          </Button>
        </div>
      </div>
    );
  }

  private onFinalizeClick = () => {
    if (!this.props.disableFinalize) {
      this.props.onFinalize();
    }
  };
}
